// extracted by mini-css-extract-plugin
module.exports = {"countdown":"AuditCountdown_countdown__3V1B2","number":"AuditCountdown_number__3fd3g"};